import classnames from 'classnames';
import style from './divider.module.less';
import type { DividerProps, DividerOrientationValues } from './divider-types';

export const HORIZONTAL: DividerOrientationValues = 'horizontal';
export const VERTICAL: DividerOrientationValues = 'vertical';

export const Divider = ({ className, orientation = HORIZONTAL }: DividerProps): JSX.Element => {
  const isHorizontal = orientation === HORIZONTAL;

  return (
    <div
      className={classnames(
        style.divider,
        {
          [style.horizontal]: isHorizontal,
          [style.vertical]: !isHorizontal,
        },
        className,
      )}
    />
  );
};
